import { type Ref, unref, computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import Billing from "@/services/billing/billing";

export interface UsageHistoryParams {
  startDate?: string;
  endDate?: string;
  usageType?: string;
  userId?: string;
  page?: number;
  perPage?: number;
}

export function useUsageHistory(params: Ref<UsageHistoryParams> | UsageHistoryParams = {}) {
  const queryKey = computed(() => ["billing", "usageHistory", unref(params)]);

  return useQuery({
    queryKey,
    queryFn: async () => {
      const p = unref(params);
      const result = await Billing.getUsageHistory(p);
      const payload = result?.data as { status?: boolean; data?: unknown };
      if (payload?.status && payload?.data != null)
        return payload.data as {
          history: unknown[];
          total: number;
          total_pages: number;
          page: number;
          limit: number;
          period_start?: string;
          period_end?: string;
        };
      return { history: [], total: 0, total_pages: 1, page: 1, limit: 50 };
    },
    staleTime: 0,
    gcTime: 10 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
